import { createDecoratedMagicEvent } from '@/features/events/lib/createDecoratedMagicEvent';
import type { MagicChatFragment } from '../fragments/ChatFragment.generated';
import type { DecoratedMagicChat } from '../types';
import { createDecoratedMagicJob } from './createDecoratedMagicJob';

export const createDecoratedMagicChat = (
  chat: MagicChatFragment
): DecoratedMagicChat => {
  return {
    ...chat,
    events: chat.events.map((rawEvent) => createDecoratedMagicEvent(rawEvent)),
    jobs: chat.jobs.map((rawJob) => createDecoratedMagicJob(rawJob)),
    messages: chat.messages || [],
    isSaved: true,
    createdAt: new Date(chat.createdAt),
    updatedAt: chat.updatedAt ? new Date(chat.updatedAt) : null,
    experienceId: chat.experienceId ?? undefined,
    experiencePublishedUrl: chat.experiencePublishedUrl ?? undefined,
  };
};
